export const packages = [
    {
        id: 1,
        title: "Travel",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "3,999",
        price2: "5,999",
        price3: "7,999",
        feature1: [
            "1 Hour shoot",
            "Unlimited Photos",
            "High Resolution 15 edited pictures",
            "1-2 locations (2 km in range)",
            "Valid upto 3 People"
        ],
        feature2: [
            "2 Hour shoot",
            "Unlimited Photos",
            "High Resolution 25 edited pictures",
            "1-2 locations (2 km in range)",
            "Valid upto 5 People"
        ],
        feature3: [
            "3 Hour shoot",
            "Unlimited Photo's",
            "High Resolution 40 edited pictures",
            "Multi locations (5 km in range)",
            "Valid upto 7 people"
        ],
    },
    {
        id: 2,
        title: "Wedding",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "34,999",
        price2: "49,999",
        price3: "69,999",
        feature1: [
            "Traditional Photography",
            "Traditional HD Videography",
            "Flash Drive with edited Video",
            "25 pages Wedding Album",
            "Instagram Reel",
            "Complimentary Surprise"
        ],
        feature2: [
            "Traditional Photography",
            "Candid Photography",
            "Traditional HD Videography",
            "Flash Drive with edited Video",
            "35 Sheet Wedding Album ",
            "Instagram Reel",
            "Complimentary Surprise"
        ],
        feature3: [
            "Traditional Photography",
            "Candid Photography",
            "Traditional HD Videography",
            "Cinematic Videography",
            "Drone shoot",
            "Flash Drive with edited videos",
            "Cinematic Wedding film",
            "35 Sheet Wedding Album ",
            "Instagram Reel",
            "Complimentary Surprise"
        ],
    },

    {
        id: 3,
        title: "Business",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "11,999",
        price2: "24,999",
        price3: "29,999",
        feature1: [
            "Traditional Photography",
            "Unlimited Photos",
            "Shoot Upto 5 hours"
        ],
        feature2: [
            "Traditional Photography",
            "Traditional Videography",
            "Unlimited Photos",
            "Flash Drive with edited videos",
            "Shoot Upto 5 hours"
        ],
        feature3: [
            "Traditional Photography",
            "Traditional Videography",
            "Drone shoot",
            "Unlimited Photo's",
            "Flash Drive with edited videos",
            "Shoot Upto 5 hours"
        ],
    },
    {
        id: 4,
        title: "Baby",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "14,999",
        price2: "29,999",
        price3: "34,999",
        feature1: [
            "Candid Photography",
            "Unlimited Photo's",
            "40 Edited Pictures",
            "Shoot Upto 5 hours"
        ],
        feature2: [
            "Candid Photography",
            "Cinematic Videography",
            "Cinematic Teaser and video",
            "Unlimited Photo's ",
            "Instagram Reels - 3",
            "Photobook - 50 Photo's",
            "Shoot Upto 5 hours"
        ],
        feature3: [
            "Candid Photography",
            "Cinematic Videography",
            "Drone Shoot",
            "Cinematic Teaser and video",
            "Unlimited Photo's ",
            "Instagram Reels - 3",
            "Photobook - 50 Photo's",
            "Shoot Upto 5 hours"
        ],
    },
    {
        id: 5,
        title: "Pre-Wedding",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "14,999",
        price2: "29,999",
        price3: "34,999",
        feature1: [
            "Candid Photography",
            "Unlimited Photo's",
            "40 Edited Pictures",
            "Countdown Pictures (5 days)",
            "Whole day Shoot"
        ],
        feature2: [
            "Candid Photography",
            "Cinematic Videography",
            "Cinematic Teaser and video",
            "Unlimited Photo's ",
            "Instagram Reels - 3",
            "Photobook - 50 Photo's",
            "Countdown Pictures (5 days)",
            "Whole day Shoot"
        ],
        feature3: [
            "Candid Photography",
            "Cinematic Videography",
            "Drone Shoot",
            "Cinematic Teaser and video",
            "Unlimited Photo's ",
            "Instagram Reels - 3",
            "Photobook - 50 Photo's",
            "Countdown Pictures (5 days)",
            "Whole day Shoot"
        ],
    },

    {
        id: 6,
        title: "Maternity",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "14,999",
        price2: "29,999",
        price3: "34,999",
        feature1: [
            "Candid Photography",
            "Unlimited Photo's",
            "40 Edited Pictures",
            "Shoot Upto 5 hours"
        ],
        feature2: [
            "Candid Photography",
            "Cinematic Videography",
            "Cinematic Teaser and video",
            "Unlimited Photo's ",
            "Instagram Reels - 3",
            "Photobook - 50 Photo's",
            "Shoot Upto 5 hours"
        ],
        feature3: [
            "Candid Photography",
            "Cinematic Videography",
            "Drone Shoot",
            "Cinematic Teaser and video",
            "Unlimited Photo's ",
            "Instagram Reels - 3",
            "Photobook - 50 Photo's",
            "Shoot Upto 5 hours"
        ],
    },
    {
        id: 7,
        title: "Personal",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "3,999",
        price2: "5,999",
        price3: "7,999",
                feature1: [
            "1 Hour shoot",
            "Unlimited Photo's",
            "High Resolution 15 edited pictures"
        ],
        feature2: [
            "1 Hour shoot",
            "Unlimited Photos",
            "High Resolution 15 edited pictures"
        ],
        feature3: [
            "3 Hour shoot",
            "Unlimited Photo's",
            "High Resolution 40 edited pictures"
        ],
    },

    {
        id: 8,
        title: "Family",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "3,999",
        price2: "5,999",
        price3: "7,999",
                feature1: [
            "1 Hour shoot",
            "Unlimited Photo's",
            "High Resolution 15 edited pictures",
            "Valid upto 3 people"
        ],
        feature2: [
            "2 Hour shoot",
            "Unlimited Photo's",
            "High Resolution 25 edited pictures",
            "Valid upto 5 people"
        ],
        feature3: [
            "3 Hour shoot",
            "Unlimited Photo's",
            "High Resolution 40 edited pictures",
            "Valid upto 7 people"
        ],
    },

    {
        id: 9,
        title: "Post-Wedding",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "14,999",
        price2: "29,999",
        price3: "34,999",
        feature1: [
            "Candid Photography",
            "Unlimited Photo's",
            "40 Edited Pictures",
            "Countdown Pictures (5 days)",
            "Whole day Shoot"
        ],
        feature2: [
            "Candid Photography",
            "Cinematic Videography",
            "Cinematic Teaser and video",
            "Unlimited Photo's ",
            "Instagram Reels - 3",
            "Photobook - 50 Photo's",
            "Countdown Pictures (5 days)",
            "Whole day Shoot"
        ],
        feature3: [
            "Candid Photography",
            "Cinematic Videography",
            "Drone Shoot",
            "Cinematic Teaser and video",
            "Unlimited Photo's ",
            "Instagram Reels - 3",
            "Photobook - 50 Photo's",
            "Countdown Pictures (5 days)",
            "Whole day Shoot"
        ],
    },

    {
        id: 10,
        title: "Other",
        heading1: "Bronze",
        heading2: "Silver",
        heading3: "Gold",
        price1: "14,999",
        price2: "24,999",
        price3: "34,999",
                feature1: [
            "Traditional Photography",
            "Traditional HD Videography"
        ],
        feature2: [
            "Traditional Photography",
            "Candid Photography",
            "Traditional HD Videography"
        ],
        feature3: [
            "Traditional Photography",
            "Candid Photography",
            "Traditional HD Videography",
            "Cinematic Videography",
            "Drone shoot"
        ],
    },
];
